module.exports = __webpack_public_path__ + "2d4aa1237291dd945b301dbd92117f6c.pdf";